import { Component } from '@theme/component';

/**
 * Flips flyout panels that would overflow the right edge of the viewport.
 * Measures lazily on pointerenter/focusin — no scroll or resize observers.
 *
 * @extends {Component}
 */
class FlyoutMenu extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('pointerenter', this.#onEnter, true);
    this.addEventListener('focusin', this.#onEnter);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('pointerenter', this.#onEnter, true);
    this.removeEventListener('focusin', this.#onEnter);
  }

  /** @param {Event} event */
  #onEnter = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const item = target.closest('.flyout-menu__item, .flyout-menu__subitem');
    if (!item) return;
    const panel = item.querySelector(':scope > .flyout-menu__panel');
    if (!(panel instanceof HTMLElement)) return;
    this.#positionPanel(panel);
  };

  /** @param {HTMLElement} panel */
  #positionPanel(panel) {
    // Reset to the default side before measuring so we read the natural position.
    panel.removeAttribute('data-side');

    // Measure on the next frame, after the open transition lays it out.
    requestAnimationFrame(() => {
      const rect = panel.getBoundingClientRect();
      const overflowsRight = rect.right > window.innerWidth - 8;
      if (overflowsRight) {
        panel.setAttribute('data-side', 'left');
      }
    });
  }
}

if (!customElements.get('flyout-menu')) {
  customElements.define('flyout-menu', FlyoutMenu);
}
